const updateQuestions = {
  toastrTrue: 'Grupo atualizado',
  toastrFalse: 'Questão atualizada',
  txt: ' foi atualizada com sucesso'
};

export default updateQuestions;
